<!--
 - Author : wanghongling.
 - Date   : 2019/7/12.
 - File   : twoLine.两条折线
 -->

<template>
  <div :id="id" :style="{width: '100%', height: twoLineList.height, margin: twoLineList.margin}">
  </div>
</template>

<script>
  export default {
    name: 'two-line',
    data() {
      return {
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      twoLineList: {}
    },
    watch: {
      twoLineList: {
        handler() {
          this.$nextTick(() => {
            // window.removeEventListener('resize', this.resizeEvent)
            this.makeTwoLine()
          })
        },
        deep: true
      }
    },
    mounted() {
      this.init()
    },
    destroyed() {
      this.$echarts.dispose(this.myTwoLine)
      // window.removeEventListener('resize', this.resizeEvent)
      this.myTwoLine = null
    },
    methods: {
      /**
       * 初始化echart
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      init() {
        this.myTwoLine = this.$echarts.init(document.getElementById(this.id))
        this.makeTwoLine()
      },
      /**
       * echart数据赋值
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      makeTwoLine() {
        let option = {
          tooltip: {
            trigger: 'axis'
            // axisPointer: {
            //   type: 'cross',
            //   label: {
            //     backgroundColor: '#57636d',
            //     show: true
            //   }
            // }
          },
          formatter: '{b}:00<br/><span style="color:#a172ed;">{a0}</span>：{c0}' + this.twoLineList.dw1 + '</br><span style="color:#02b5d5;">{a1}</span>：{c1}' + this.twoLineList.dw2,
          grid: {
            left: this.twoLineList.gridLeft || '5%',
            right: this.twoLineList.gridRight || '5%',
            top: this.twoLineList.gridTop || '20%',
            bottom: this.twoLineList.gridBottom || '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            offset: 0,
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#00d6ff'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#00d6ff'
              }
            },
            data: this.twoLineList.xData
          },
          yAxis:
            [
              {
                type: 'value',
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#00d6ff'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ['#014778'],
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  textStyle: {
                    color: '#00d6ff'
                  }
                },
                name: this.twoLineList.yName[0] || '耗电量 单位：kWh',
                nameTextStyle: {
                  align: 'left'
                },
                position: 'left'
              },
              {
                type: 'value',
                min: 0,
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#00d6ff'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: '#00d6ff'
                  }
                },
                name: this.twoLineList.yName[1] || '功率 单位：w',
                position: 'right'
              }
            ],
          series: [
            {
              name: this.twoLineList.xName[0] || '累计能耗',
              type: 'line',
              animationDuration: 3000,
              animationDurationUpdate: 3000,
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#a173ed'
                }
              },
              data: this.twoLineList.data1
            },
            {
              name: this.twoLineList.xName[1] || '当前功率',
              type: 'line',
              yAxisIndex: 1,
              animationDuration: 3000,
              animationDurationUpdate: 3000,
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#02b5d5'
                }
              },
              data: this.twoLineList.data2
            }
          ]
        }
        this.myTwoLine.setOption(option)
        // window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent() {
        this.myTwoLine.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/twoLine.vue